import type { SavedNightjarOrder } from '@/domain/WorkspaceForex/savedProducts/order/SavedNightjarOrder.ts';
import type { NightjarOrder } from '@/store/orders/algoOrders/state.ts';

export const mapToNightjar = (savedTile: SavedNightjarOrder): NightjarOrder => {
  return {
    ...savedTile,
    properties: {
      ...savedTile.properties,
    },
  };
};
